<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md4>
        <v-card outlined>
          <v-card-text>
            {{ $t("general.openWebPage", { linkName: $route.params.link }) }}
          </v-card-text>
          <v-card-text>
            <v-progress-linear indeterminate></v-progress-linear>
          </v-card-text>
          <v-card-actions>
            <v-btn text block color="primary" @click="abortRedirect">{{
              $t("modal.cancel")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      redirectTimeout: undefined,
    };
  },
  mounted() {
    this.redirectTimeout = setTimeout(() => {
      if (this.$config.OPEN_LINK_NEW_TAB) {
        window.open(this.$route.params.link, "_system");
        this.$router.back();
      } else {
        location.replace(this.$route.params.link);
      }
    }, 1000);
  },
  methods: {
    abortRedirect() {
      clearTimeout(this.redirectTimeout);
      this.$router.push({ name: "home" });
    },
  },
};
</script>
